import React, { useState } from 'react';
import style from '../css/Contact.module.css';
import Footer from '../components/Footer';
import FeedbackList from '../components/FeedbackList';

function Contact() {
	const [formData, setFormData] = useState({
		name: '',
		phone: '',
		email: '',
		location: '', // Added location field
		service: '',
		message: '',
	});
	const [loading, setLoading] = useState(false);
	const [responseMsg, setResponseMsg] = useState('');

	// Handle input change
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setResponseMsg('');

		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/NewBooking.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(formData),
				}
			);
			const result = await response.json();

			if (result.status) {
				setResponseMsg('Your inquiry has been submitted successfully!');
				setFormData({
					name: '',
					phone: '',
					email: '',
					location: '',
					service: '',
					message: '',
				}); // Reset form
			} else {
				setResponseMsg('Failed to submit. Please try again.');
			}
		} catch (error) {
			setResponseMsg(
				'Error submitting form. Please check your internet connection.'
			);
		}

		setLoading(false);
	};

	return (
		<div>
			<div className={style.container}>
				<h2 className={style.title}>Contact Us</h2>
				<p className={style.subtitle}>
					Contact us about anything related to our company or services. We'll do
					our best to get back to you as soon as possible.
				</p>

				<form className={style.form} onSubmit={handleSubmit}>
					<div className={style.row}>
						<input
							type="text"
							name="name"
							placeholder="Name *"
							className={style.input}
							value={formData.name}
							onChange={handleChange}
							required
						/>
						<input
							type="text"
							name="phone"
							placeholder="Phone Number *"
							className={style.input}
							value={formData.phone}
							onChange={handleChange}
							required
						/>
					</div>

					<div className={style.row}>
						<input
							type="email"
							name="email"
							placeholder="Email *"
							className={style.input}
							value={formData.email}
							onChange={handleChange}
							required
						/>
					</div>

					{/* Location Dropdown */}
					<select
						name="location"
						className={style.input}
						value={formData.location}
						onChange={handleChange}
						required
					>
						<option value="">Select Location *</option>
						<option value="Bangalore/Bengaluru">Bangalore/Bengaluru</option>
						<option value="Dhanbad">Dhanbad</option>
					</select>

					{/* Service Dropdown */}
					<select
						name="service"
						className={style.input}
						value={formData.service}
						onChange={handleChange}
						required
					>
						<option value="">Select Service *</option>
						<option value="Washing Machine Repairs">
							Washing Machine Repairs
						</option>
						<option value="Refrigerator Repair Services">
							Refrigerator Repair Services
						</option>
						<option value="Air Conditioner (AC) Repairs">
							Air Conditioner (AC) Repairs
						</option>
						<option value="Microwave Oven Repairs">
							Microwave Oven Repairs
						</option>
						<option value="TV Repairs">TV Repairs</option>
						<option value="Cooler Repairs">Cooler Repairs</option>
						<option value="Dish Washer Repairs">Dish Washer Repairs</option>
					</select>

					<textarea
						name="message"
						placeholder="Your Message"
						rows="4"
						className={style.textarea}
						value={formData.message}
						onChange={handleChange}
					></textarea>

					<button type="submit" className={style.button} disabled={loading}>
						{loading ? 'Submitting...' : 'Submit'}
					</button>

					{responseMsg && <p className={style.response}>{responseMsg}</p>}
				</form>
			</div>
			<FeedbackList />
			<Footer />
		</div>
	);
}

export default Contact;
